import React from 'react'
import Landing from '../components/Landing/Landing'

const Home = () => {
  return (
    <main>
      <div className='container full'>
        <Landing />
      </div>
    </main>
  )
}

export default Home
